import { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

export const ActionsCell = ({ row, onEdit, onClaim, onUnclaim, onComplete, currentUser }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (action) => {
    switch (action) {
      case 'edit':
        onEdit(row.original);
        break;
      case 'claim':
        onClaim(row.original);
        break;
      case 'unclaim':
        onUnclaim(row.original);
        break;
      case 'complete':
        onComplete(row.original);
        break;
    }
    handleClose();
  };

  const isClaimDisabled = row.original.claimed_by !== null && row.original.claimed_by !== currentUser;
  const isClaimedByCurrentUser = row.original.claimed_by === currentUser;

  return (
    <>
      <IconButton
        onClick={handleClick}
        aria-label="more actions"
        aria-controls={open ? 'actions-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="actions-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'actions-button',
        }}
      >
        <MenuItem 
          onClick={() => handleAction('edit')}
          sx={{
            color: 'default.main',
          }}
        >
          Edit
        </MenuItem>
        {isClaimedByCurrentUser &&
          <MenuItem 
            onClick={() => handleAction('unclaim')}
            sx={{
              color: 'error.main',
            }}
          >
            Unclaim
          </MenuItem>
        }
        {!isClaimedByCurrentUser &&
          <MenuItem 
            onClick={() => handleAction('claim')}
            disabled={isClaimDisabled}
            sx={{
              color: 'default.main',
            }}
          >
            {isClaimDisabled ? 'Claimed' : 'Claim'}
          </MenuItem>
        }
        <MenuItem 
          onClick={() => handleAction('complete')}
          sx={{
            color: 'green',
          }}
        >
          Complete
        </MenuItem>
      </Menu>
    </>
  );
};